import { createMessageName } from '@formkit/validation';
import { sentence, date, list } from '../formatters.mjs';

// packages/i18n/src/locales/fa.ts
var add = "افزودن";
var remove = "حذف";
var removeAll = "همه را حذف کنید";
var incomplete = "همه فیلدها به‌درستی پر نشده‌اند";
var submit = "ثبت";
var noFiles = "هیچ فایلی انتخاب نشده است";
var moveUp = "حرکت به بالا";
var moveDown = "حرکت به پایین";
var isLoading = "در حال بارگذاری...";
var loadMore = "بارگذاری بیشتر";
var next = "بعدی";
var prev = "قبلی";
var addAllValues = "تمام مقادیر را اضافه کنید";
var addSelectedValues = "مقادیر انتخاب شده را اضافه کنید";
var removeAllValues = "تمام مقادیر را حذف کنید";
var removeSelectedValues = "حذف مقادیر انتخاب شده";
var chooseDate = "تاریخ را انتخاب کنید";
var changeDate = "تغییر تاریخ";
var close = "بستن";
var open = "باز کردن";
var accepted = function({
  name
}) {
  return `لطفاً ${name} را بپذیرید.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} باید بعد از تاریخ ${date(args[0])} باشد.`;
  }
  return `${sentence(name)} باید مربوط به آینده باشد.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} فقط میتواند شامل حروف الفبا باشد.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} فقط میتواند شامل حروف و اعداد باشد.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} فقط می تواند شامل حروف و فاصله باشد.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} باید حاوی حروف الفبا باشد.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} باید حاوی حروف یا اعداد باشد.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} باید حاوی حروف یا فاصله باشد.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} باید حاوی نماد باشد.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} باید دارای حروف بزرگ باشد.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} باید حاوی حروف کوچک باشد.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} باید حاوی اعداد باشد.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} باید یک نماد باشد.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} تنها می‌تواند شامل حروف بزرگ باشد.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} تنها می‌تواند شامل حروف کوچک باشد.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} باید قبل از تاریخ ${date(args[0])} باشد.`;
  }
  return `${sentence(name)} باید مربوط به گذشته باشد.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `این فیلد به اشتباه پیکربندی شده است و قابل ارسال نیست`;
  }
  return `${sentence(name)} باید بین ${args[0]} و ${args[1]} باشد.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} مطابقت ندارد.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} تاریخ معتبری نیست، لطفاً از قالب ${args[0]} استفاده کنید
`;
  }
  return "این فیلد به اشتباه پیکربندی شده است و قابل ارسال نیست";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} باید بین ${date(args[0])} و ${date(args[1])} باشد.`;
};
var email = "لطفا آدرس ایمیل معتبر وارد کنید.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} باید به ${list(args)} ختم شود.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} مجاز نیست.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = first <= second ? first : second;
  const max2 = second >= first ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} باید حداقل یک کاراکتر باشد.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} باید کمتر یا برابر با ${max2} کاراکتر باشد.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} باید ${max2} کاراکتر طولانی باشد.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} باید بزرگتر یا برابر با ${min2} کاراکتر باشد.`;
  }
  return `${sentence(name)} باید بین ${min2} و ${max2} کاراکتر باشد.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} مجاز نیست.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${name} نمی تواند بیش از ${args[0]} باشد.`;
  }
  return `${sentence(name)} باید کمتر یا برابر با ${args[0]} باشد.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "فرمت فایل مجاز نیست.";
  }
  return `${sentence(name)} باید از این نوع باشد: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${name} نمی تواند کمتر از ${args[0]} باشد.
`;
  }
  return `${sentence(name)} باید حداقل ${args[0]} باشد.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `"${value}" یک ${name} مجاز نیست.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} باید عدد باشد.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" یا ")} مورد نیاز است.`;
};
var required = function({
  name
}) {
  return `پر کردن ${sentence(name)} اجباری است.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} باید با ${list(args)} شروع شود.`;
};
var url = function() {
  return `لطفا یک URL معتبر وارد کنید.`;
};
var invalidDate = "تاریخ انتخاب شده نامعتبر است";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var fa_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, fa_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=fa.mjs.map